import { fromJS, Map } from "immutable";
import * as actionTypes from "~/store/action_types";

const userInternalRates = (state = new Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_INTERNAL_RATES_SUCCESS:
      if (!action.response || !action.response.entities || !action.response.entities.internal_rates) {
        return state;
      }
      return fromJS(action.response.entities.internal_rates);
    case actionTypes.FETCH_ALL_INTERNAL_RATES_ERROR:
      return Map();
    case actionTypes.ADD_USER_INTERNAL_RATE_SUCCESS:
    case actionTypes.UPDATE_USER_INTERNAL_RATE_SUCCESS: {
      if (!action.response || !action.response.result || !action.response.result.single) {
        return state;
      }
      const { response = {} } = action;
      const { result = {}, entities = {} } = response;
      const { single: id } = result;
      const { internal_rates = {} } = entities;

      return state.set(`${id}`, fromJS(internal_rates[`${id}`] || {}));
    }
    case actionTypes.DELETE_USER_INTERNAL_RATE_SUCCESS: {
      const { id } = action;
      if (!id) {
        return state;
      }
      return state.remove(`${id}`);
    }
    default:
      return state;
  }
};

export default userInternalRates;
